if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.buyButton = this.productSection.querySelector('button[type="submit"], .buy-button');
      this.imageGallery = this.productSection.querySelector('#product-media');

      this.isBuyButtonVisible = false;
      this.isGalleryVisible = false;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.buyButton) {
            this.isBuyButtonVisible = entry.isIntersecting;
          }
          if (entry.target === this.imageGallery) {
            this.isGalleryVisible = entry.isIntersecting;
          }

          // Overlay nur zeigen, wenn beide nicht sichtbar sind
          this.classList.toggle(
            'sticky-atc-panel--out',
            this.isBuyButtonVisible || this.isGalleryVisible
          );
        });
      }, {
        threshold: 0.01
      });

      if (this.buyButton) observer.observe(this.buyButton);
      if (this.imageGallery) observer.observe(this.imageGallery);

      // Ausblenden am Seitenende
      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}